import type { BaseCategories } from '../types';

// Base category definitions - models will be filtered by actual inventory
// Images are stored in public/images/categories/
export const BASE_CATEGORIES: BaseCategories = {
  trucks: {
    name: 'Trucks',
    icon: '🚛',
    image: '/images/categories/trucks.png',
    modelNames: ['Silverado 1500', 'Silverado 2500HD', 'Silverado 3500HD', 'Colorado', 'Silverado MD'],
    cabOptions: {
      'Silverado 1500': ['Regular Cab', 'Double Cab', 'Crew Cab'],
      'Silverado 2500HD': ['Regular Cab', 'Double Cab', 'Crew Cab'],
      'Silverado 3500HD': ['Regular Cab', 'Double Cab', 'Crew Cab'],
      'Colorado': ['Extended Cab', 'Crew Cab'],
    },
  },
  suvs: {
    name: 'SUVs & Crossovers',
    icon: '🚙',
    image: '/images/categories/suv_and_crossovers.png',
    modelNames: ['Trax', 'Trailblazer', 'Equinox', 'Blazer', 'Traverse', 'Tahoe', 'Suburban'],
  },
  sports: {
    name: 'Sports Cars',
    icon: '🏎️',
    image: '/images/categories/sportscar.png',
    modelNames: ['Corvette', 'Camaro'],
  },
  sedans: {
    name: 'Sedans',
    icon: '🚗',
    // No image provided - will use emoji fallback
    modelNames: ['Malibu'],
  },
  electric: {
    name: 'Electric',
    icon: '⚡',
    image: '/images/categories/electric.png',
    modelNames: ['Bolt EV', 'Bolt EUV', 'Equinox EV', 'Blazer EV', 'Silverado EV'],
  },
};

/**
 * Normalize model names for matching
 * Converts to lowercase and trims whitespace
 */
export const normalizeModelName = (name: string): string => {
  return name.toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
};

/**
 * Check if inventory model matches a category model
 * Handles exact matches and special cases for GM naming conventions
 */
export const modelMatches = (inventoryModel: string, categoryModel: string): boolean => {
  const invNorm = normalizeModelName(inventoryModel);
  const catNorm = normalizeModelName(categoryModel);
  
  // Exact match
  if (invNorm === catNorm) return true;
  
  // Inventory model starts with category model (e.g., "Silverado 1500" matches "Silverado 1500 LT")
  if (invNorm.startsWith(catNorm)) return true;
  
  // Handle special cases for GM model naming
  if (catNorm === 'silverado 2500hd' && invNorm.includes('2500')) return true;
  if (catNorm === 'silverado 3500hd' && (invNorm.includes('3500') || invNorm.includes('3500hd cc'))) return true;
  if (catNorm === 'equinox ev' && invNorm === 'equinox ev') return true;
  if (catNorm === 'equinox' && invNorm === 'equinox' && !invNorm.includes('ev')) return true;
  if (catNorm === 'silverado ev' && invNorm === 'silverado ev') return true;
  
  return false;
};
